export default "__VITE_ASSET__pR9b0kkV__"